import { NavigationBar } from '@capgo/capacitor-navigation-bar';

export const setupNavigationBar = async (isDarkMode = false) => {
	try {
		const result = await NavigationBar.setNavigationBarColor({
			color: isDarkMode ? '#000000' : '#FFFFFF',
			darkButtons: !isDarkMode,
		});
		console.log(
			'🌟\tNavigation bar set to ',
			isDarkMode ? 'dark' : 'light',
			result
		);
	} catch (error) {
		console.error('Error setting navigation bar color:', error);
	}
};
